module.exports = __webpack_public_path__ + "img/suzuki.b27df022.png";